// src/serviceWorkerRegistration.ts
const isLocalhost = Boolean(
    window.location.hostname === 'localhost' ||
    // [::1] ist IPv6-Loopback
    window.location.hostname === '[::1]' ||
    // 127.0.0.0/8 IPv4-Loopback
    window.location.hostname.match(
        /^127(?:\.(?:25[0-5]|2[0-4]\d|[01]?\d?\d)){3}$/
    )
);

type Config = {
    onSuccess?: (registration: ServiceWorkerRegistration) => void;
    onUpdate?: (registration: ServiceWorkerRegistration) => void;
};

export function register(config?: Config) {
    if (process.env.NODE_ENV === 'production' && 'serviceWorker' in navigator) {
        const publicUrl = new URL(
            (process as any).env.PUBLIC_URL,
            window.location.href
        );
        if (publicUrl.origin !== window.location.origin) {
            // unterschiedlicher Ursprung → SW nicht registrieren
            return;
        }

        window.addEventListener('load', () => {
            const swUrl = `${process.env.PUBLIC_URL}/service-worker.js`;

            if (isLocalhost) {
                // localhost: Checke SW zuerst und logge ggf. Fehler
                fetch(swUrl, { headers: { 'Service-Worker': 'script' } })
                    .then(response => {
                        const contentType = response.headers.get('content-type');
                        if (
                            response.status === 404 ||
                            (contentType != null && contentType.indexOf('javascript') === -1)
                        ) {
                            navigator.serviceWorker.ready.then(reg => reg.unregister());
                        } else {
                            registerValidSW(swUrl, config);
                        }
                    })
                    .catch(() => {
                        console.log('Kein Internet – App läuft im Offline-Modus.');
                    });
            } else {
                // in Produktion
                registerValidSW(swUrl, config);
            }
        });
    }
}

function registerValidSW(swUrl: string, config?: Config) {
    navigator.serviceWorker
        .register(swUrl)
        .then(registration => {
            registration.onupdatefound = () => {
                const installingWorker = registration.installing;
                if (!installingWorker) return;
                installingWorker.onstatechange = () => {
                    if (installingWorker.state === 'installed') {
                        if (navigator.serviceWorker.controller) {
                            // Neue Inhalte verfügbar
                            console.log('Neue Inhalte verfügbar – bitte Seite neu laden.');
                            config?.onUpdate?.(registration);
                        } else {
                            // Inhalte zwischengespeichert
                            console.log('Inhalte jetzt im Cache verfügbar.');
                            config?.onSuccess?.(registration);
                        }
                    }
                };
            };
        })
        .catch(error => {
            console.error('Service Worker Registrierung fehlgeschlagen:', error);
        });
}

export function unregister() {
    if ('serviceWorker' in navigator) {
        navigator.serviceWorker.ready
            .then(registration => {
                registration.unregister();
            })
            .catch(error => {
                console.error(error.message);
            });
    }
}
